import { format, parse, parseISO } from 'date-fns'
import { enUS, es } from 'date-fns/locale'

export function formatMysqlDate(date: string, language: string = "en") {
  const locale  = language == "es" ? es : enUS
  return format(parseISO(date), 'MMMM d yyyy', {locale})
}

export function YYYYMMDDToJsDate(date: string) {
  return parse(date, 'yyyy-MM-dd', new Date())
}